export const APP_NAME = 'Scratch for School';
